import $config from '@/services/config';

let storage = {
    get: (key, defaultValue) => localStorage.getItem($config.get('STORAGE_KEY') + '-' + key) || defaultValue,
    put: (key, value) => localStorage.setItem($config.get('STORAGE_KEY') + '-' + key, value),
    delete: (key) => localStorage.removeItem($config.get('STORAGE_KEY') + '-' + key),
};

storage.getInt = (key, defaultValue) => parseInt(storage.get(key, defaultValue));
storage.getFloat = (key, defaultValue) => parseFloat(storage.get(key, defaultValue));

export default storage;
